import MockUser from '../assets/current_user.json'

/**
 * Fetches the user who's currently logged in the Algolia dashboard
 * @param {String} host - Your current host
 * @param {Array} prodHosts - The hosts for which you want to fetch the actual current user
 * @returns {Promise} A Promise resolving with ther user details
 */
export default function(host) {
  if (parseInt(new URL(location).searchParams.get('user'), 10) === 0)
    return new Promise(resolve => resolve({}))
  return host === '' || typeof host === 'undefined'
    ? new Promise(resolve => resolve(MockUser))
    : fetch(`${host}/static/current_user`).then(response => response.json())
}
